export default __webpack_public_path__ + "static/media/card-project2.e44ac3c5.jpg";